import { Storage } from '../models/storage';
import { Window } from '../models/window';
import { Edge } from '../models/edge';
import _ from 'lodash';

export const STORAGE: Storage = {
  projectName: '',
  systemType: null,
  buildingType: null,
  windowType: null,
  frameType: null,
  windows: []
};

export const EDGE: Edge = {
  width: 30,
  length: 1500,
  depth: 30,
};

export const WINDOW: Window = {
  id: 1,
  type: null,
  amount: 1,
  standard: {
    side: 'INSIDE',
    inside: {
      isSameDepth: true,
      depth: 30,
      edges: [
        _.cloneDeep(EDGE),
        _.cloneDeep(EDGE),
        _.cloneDeep(EDGE),
        _.cloneDeep(EDGE)
      ],
    },
    outside: {
      isSameDepth: true,
      depth: 30,
      edges: [
        _.cloneDeep(EDGE),
        _.cloneDeep(EDGE),
        _.cloneDeep(EDGE),
        _.cloneDeep(EDGE)
      ],
    },
  },
  nonstandard: {
    side: 'INSIDE',
    inside: {
      edges: []
    },
    outside: {
      edges: []
    },
  }
};

export const FIND_SYSTEM_RULES = [
  {path: [1, 1, 1], system: [2, 3]},
  {path: [1, 2, 1], system: [2, 3]},
  {path: [1, 1, 2], system: [1]},
  {path: [1, 2, 2], system: [1]},
  {path: [2, 1, 1], system: [3, 2]},
  {path: [2, 2, 1], system: [3, 2]},
  {path: [2, 1, 2], system: [1]},
  {path: [2, 2, 2], system: [1]},
];

